export default __webpack_public_path__ + "static/media/screenshot-1.d2939adf.png";